import "./App.css";
import FooterBar from "./Componentes/Layout/FooterBar";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Corpo from "./Componentes/Paginas/Corpo";
import EquipeP from "./Componentes/Paginas/EquipeP";
import ReferencialP from "./Componentes/Paginas/ReferencialP";
import ResultadosP from "./Componentes/Paginas/ResultadosP";

import AjustaRolagem from "./Componentes/AjustaRolagem";

function App() {
  return (
    <Router className="App">
      <AjustaRolagem>
        <Routes>
          <Route exact path="/" element={<Corpo />}></Route>
          <Route exact path="/equipep" element={<EquipeP />}></Route>
          <Route exact path="/referencialp" element={<ReferencialP />}></Route>
          <Route exact path="/resultadosp" element={<ResultadosP />}></Route>
        </Routes>
        <FooterBar></FooterBar>
      </AjustaRolagem>
    </Router>
  );
}

export default App;
